import React from 'react';
import { Link, browserHistory } from 'react-router';
import logo from '../../../html/assets/images/motoamerica.png';
import logo2x from '../../../html/assets/images/motoamerica@2x.png';

const MALogo = ({showHelp, showClose, showLogout, onLogoutClick}) => (
  <div className="row row-head">
    {showClose && <CloseLink />}
    {showHelp && <HelpLink />}
    {showLogout && <LogoutLink onClick={() => onLogoutClick()} />}
    <div className="col-xs-12 col-md-8 col-md-offset-2">
      <img src={logo} srcSet={`${logo} 1x, ${logo2x} 2x`} alt="motoamericareg logo" />
    </div>
  </div>
);

const HelpLink = () => <Link to="/help" className="pull-left">Help</Link>;

const CloseLink = () => (
  <Link onClick={() => browserHistory.goBack()} className="pull-left">
    <div className="icon-white_close"></div>
  </Link>
);

const LogoutLink = ({onClick}) => <Link to="#" onClick={() => onClick()} className="pull-right">Logout</Link>;

export default MALogo;



// WEBPACK FOOTER //
// ./src/components/LoginForm/MALogo.js